import { PageName } from '@anm/data/video-templates/pages';

export type CategoryItemProps = {
  label: string;
  page: PageName;
  isOwnCategory?: boolean;
  isHighlighted?: boolean;
};

export type CategoryItem = CategoryItemProps & {
  list: CategoryItemProps[][];
};

const headerCategories = [
  {
    label: 'image templates',
    page: 'image',
    list: [
      [
        {label: 'thumbnail', page: 'thumbnail'},
        {label: 'lower third', page: 'lower-third'},
        {label: 'meme', page: 'meme' },
        {label: 'facebook cover', page: 'facebook-cover' },
        {label: 'quote', page: 'quote' },
        {label: 'overlay', page: 'overlay' }
      ]
    ]
  },
  {
    label: 'live streaming',
    page: 'live-streaming',
    list: [
      [
        {
          label: 'transparent lower third',
          page: 'trn-lower-third'
        },
        {
          label: 'technical difficulties',
          page: 'tech-diffs-screens'
        },
        {
          label: 'be right back screen',
          page: 'brb-screens'
        },
        {
          label: 'live stream promo',
          page: 'promo'
        },
        {
          label: 'all styles',
          page: 'live-streaming',
          isOwnCategory: true,
          isHighlighted: true
        }
      ],
      [
        {
          label: 'starting soon screen',
          page: 'starting-soon'
        },
        {
          label: 'frame overlay',
          page: 'frame-overlay'
        },
        {
          label: 'key takeaways',
          page: 'key-takeaway'
        },
        {
          label: 'Q&A screen',
          page: 'qa'
        }
      ],
      [
        {
          label: 'countdown',
          page: 'countdown'
        },
        {
          label: 'thumbnail',
          page: 'thumbnails'
        },
        {
          label: 'intro',
          page: 'intro'
        },
        {
          label: 'outro',
          page: 'ended-screen'
        }
      ]
    ]
  },
  {
    label: 'trending',
    page: 'trending',
    list: [
      [
        {
          label: 'zoom backgrounds',
          page: 'use-cases-zoom-backgrounds',
          isOwnCategory: true
        },
        {
          label: 'frame videos templates',
          page: 'use-cases-frame',
          isOwnCategory: true
        },
        {
          label: 'collage video templates',
          page: 'use-cases-collage',
          isOwnCategory: true
        },
        {
          label: 'holiday video templates',
          page: 'holidays',
          isOwnCategory: true
        },
        {
          label: 'animated video templates',
          page: 'use-cases-animated',
          isOwnCategory: true
        },
        {
          label: 'Intro/Outro video templates',
          page: 'use-cases-intro-outro',
          isOwnCategory: true
        }
      ]
    ]
  },
  {
    label: 'Social Media',
    page: 'social-media',
    list: [
      [
        { label: 'youTube video', page: 'youtube' },
        { label: 'facebook video', page: 'facebook' },
        { label: 'instagram video', page: 'instagram' },
        { label: 'twitter video', page: 'twitter' },
        { label: 'linkedIn video', page: 'linkedin' }
      ],
      [
        { label: 'reels and stories', page: 'stories' },
        { label: 'youtube shorts', page: 'youtube-shorts' },
        { label: 'tikTok video', page: 'tiktok' },
        { label: 'pinterest video', page: 'pinterest' },
        { label: 'trending Hashtags', page: 'trending-hashtags' }
      ]
    ]
  },
  {
    label: 'Ads & Promo',
    page: 'ads-promo',
    list: [
      [
        {
          label: 'News Video',
          page: 'use-cases-news',
          isOwnCategory: true
        },
        {
          label: 'Quotes Video',
          page: 'use-cases-quotes',
          isOwnCategory: true
        },
        { label: 'Ads Video Templates', page: 'ads' },
        { label: 'Promo Video Templates', page: 'promo' },
        { label: 'Customer Testimonial', page: 'testimonials' }
      ]
    ]
  },
  {
    label: 'Industries',
    page: 'industry',
    list: [
      [
        { label: 'pets', page: 'pets' },
        { label: 'music', page: 'music' },
        { label: 'travel', page: 'travel' },
        { label: 'wedding', page: 'wedding' },
        { label: 'fashion', page: 'fashion' },
        { label: 'business', page: 'business' }
      ],
      [
        { label: 'education', page: 'education' },
        { label: 'lifestyle', page: 'lifestyle' },
        { label: 'marketing', page: 'marketing' },
        { label: 'healthcare', page: 'healthcare' },
        { label: 'e-commerce', page: 'e-commerce' }
      ],
      [
        { label: 'technology', page: 'technology' },
        { label: 'video games', page: 'video-game' },
        { label: 'real estate', page: 'real-estate' },
        { label: 'Beauty & Care', page: 'beauty' },
        { label: 'entertainment', page: 'entertainment' }
      ],
      [
        { label: 'art & culture', page: 'art-and-culture' },
        { label: 'sport & wellness', page: 'sports-and-fitness' },
        { label: 'food & restaurants', page: 'food' },
        { label: 'Nature & Environment', page: 'nature' },
        { label: 'architecture & design', page: 'architecture-and-design' }
      ]
    ]
  },
  {
    label: 'Use Cases',
    page: 'use-cases',
    list: [
      [
        { label: 'Memes', page: 'memes' },
        { label: 'listicles', page: 'listicles' },
        { label: 'tutorials', page: 'tutorials' },
        { label: 'greetings', page: 'greeting' },
        { label: 'slideshow', page: 'slideshow' },
        { label: 'News Video', page: 'news' },
        { label: 'Trailers', page: 'trailers' }
      ],
      [
        { label: 'travel vlog', page: 'travel-vlog' },
        { label: 'countdown', page: 'countdown' },
        { label: 'lyric Video', page: 'lyric' },
        { label: 'video quotes', page: 'quotes' },
        { label: 'product demo', page: 'product-demo' },
        { label: 'lower thirds', page: 'lower-third' }
      ],
      [
        { label: 'recipe videos', page: 'recipe' },
        { label: 'intro & outro', page: 'intro-outro' },
        { label: 'website video', page: 'website-video' },
        { label: 'blog promotion', page: 'blog-promotion' },
        { label: 'event promotion', page: 'event-promotion' },
        { label: 'fun social posts', page: 'fun-social-posts' }
      ],
      [
        { label: 'restaurant promo', page: 'restaurant-promo' },
        { label: 'Zoom Backgrounds', page: 'zoom-backgrounds' },
        { label: 'podcast promotion', page: 'podcast-promotion' },
        { label: 'background videos', page: 'background-video' },
        { label: 'presentation videos', page: 'presentation' },
        { label: 'Special Offers & Sales', page: 'special-offers' }
      ]
    ]
  },
  {
    label: 'Holidays',
    page: 'holidays',
    list: [
      [
        { label: 'easter', page: 'easter' },
        { label: 'birthday', page: 'birthday' },
        { label: 'christmas', page: 'christmas' },
        { label: 'labor day', page: 'labor-day' },
        { label: 'halloween', page: 'halloween' },
        { label: 'Mother’s Day', page: 'mothers-day' }
      ],
      [
        { label: 'Father’s Day', page: 'fathers-day' },
        { label: 'observances', page: 'observances' },
        { label: 'thanksgiving', page: 'thanksgiving' },
        { label: 'memorial day', page: 'memorial-day' },
        { label: 'black friday', page: 'black-friday-cyber-monday' }
      ],
      [
        { label: 'Valentine’s Day', page: 'valentines-day' },
        { label: 'back to school', page: 'back-to-school' },
        { label: 'holiday season', page: 'season' },
        { label: 'independence day', page: 'independence-day' },
        { label: "st. patrick's day", page: 'st-patricks-day' }
      ]
    ]
  }
] as CategoryItem[];

export default headerCategories;
